import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, FieldArray } from "formik";
import DropDown from "./dropDown";
import { currentLocale } from "../locale";
import "./ParticipantForm.scss";
import { participantsAgeTest, validateName, setOrdinal } from "./validation";
import BirthDate from "./BirthDate";
import {
    getLinkedParticipants,
    removeParticipant
} from "../action-creators/signedWaiver";
import { compose, filter, gte, pluck, props } from "ramda";
import { NEXT_SELECTED } from "../constants";

class LinkedParticipantList extends Component {
    constructor(props) {
        super(props);
        this.handleLinkedParticipants = this.handleLinkedParticipants.bind(this);
        this.state = {
            stateParticipantData: {
                name: "",
                participants: this.props.participants,
                linkedParticipant: [
                    {
                        participantName: "",
                        participantId: "",
                        participantBirthday: "",
                        referenceKey: ""
                    }
                ],
                linkedParticipants: [
                    {
                        participantName: "",
                        participantId: "",
                        participantBirthday: "",
                        referenceKey: ""
                    }
                ],
                role: this.props.signingInfo.role,
                selected: []
            }
        };
    }

    handleLinkedParticipants = (event, name, index) => {
        const selectedPersonNames = compose(
            pluck("participantName"),
            filter(p => p.participantId === Number(event))
        )(this.props.participants);

        const selectedReferenceKey = compose(
            pluck("referenceKey"),
            filter(p => p.participantId === Number(event))
        )(this.props.participants);

        if (isNaN(event)) {
            this.props.form.setFieldValue(
                `${name}[${index}].participantName`,
                event.target.value
            );
        } else {
            this.props.form.setFieldValue(
                `linkedParticipants[${index}].participantName`,
                selectedPersonNames.join()
            );
            this.props.form.setFieldValue(
                `linkedParticipant[0].participantBirthday`,
                this.props.form.values.birthday
            );
            this.props.form.setFieldValue(
                `linkedParticipants[${index}].referenceKey`,
                selectedReferenceKey.join()
            );
            this.props.getLinkedParticipants(event);
        }
    };

    handleDeleted = (event, arrayHelpers, index) => {
        arrayHelpers.remove(`${index}`);

        let participant = this.props.form.values.linkedParticipants[`${index}`]
            .participantName;
        this.props.removeParticipant(participant);
    };

    render() {
        const { form, waiver, name, nextSelected, index } = this.props;
        return (
            <div className="linked-participant-list">
                <Field
                    className="linked-participant-list"
                    index={index}
                    name="linkedParticipants"
                    value={form.values.linkedParticipants}
                    render={() => (
                        <FieldArray
                            waiver={waiver}
                            name="linkedParticipants"
                            render={arrayHelpers => (
                                <div>
                                    <div className="columns is-mobile">
                                        <div className="column">
                                            <h1 className="title is-5">
                                                {waiver.birthday
                                                    ? `${currentLocale.imSigning} ${
                                                    currentLocale.andBirthday
                                                    }` //&nbsp;
                                                    : `${currentLocale.imSigning}`}
                                            </h1>
                                            <h2 className="title is-6">{currentLocale.oneName}</h2>
                                        </div>
                                    </div>

                                    {form.values.linkedParticipants &&
                                        form.values.linkedParticipants.length > 0 ? (
                                            form.values.linkedParticipants.map((participant, index) => (
                                                <div key={index} className="columns is-mobile">
                                                    <div className="column is-left">
                                                        <Field
                                                            pathParticipants={props.pathParticipants}
                                                            locationData={props.locationData}
                                                            waiver={waiver}
                                                            validate={validateName}
                                                            index={index}
                                                            placeholder={`${setOrdinal(Number(index) + 1)} ${
                                                                currentLocale.minorNamePlaceHolder
                                                                }`}
                                                            className="input"
                                                            name={`linkedParticipants[${index}].participantName`}
                                                            ref={this.setTextInputRef2}
                                                            onChange={event =>
                                                                this.handleLinkedParticipants(event, name, index)
                                                            }
                                                            value={
                                                                form.values.linkedParticipants[index]
                                                                    .participantName
                                                            }
                                                            component={DropDown}
                                                        />
                                                    </div>

                                                    {waiver.birthday ? (
                                                        <div className="column is-right">
                                                            <Field
                                                                waiver={waiver}
                                                                className="input"
                                                                validate={participantsAgeTest}
                                                                name={`linkedParticipants[${index}].participantBirthday`}
                                                                value={
                                                                    form.values.linkedParticipants[index]
                                                                        .participantBirthday
                                                                }
                                                                placeholder={currentLocale.datePlaceholder}
                                                                component={BirthDate}
                                                            />
                                                        </div>
                                                    ) : null}

                                                    {gte(index, 1) ? (
                                                        <div className="column is-narrow">
                                                            <span className="label" />
                                                            <button
                                                                className="button is-primary"
                                                                type="button"
                                                                onClick={e =>
                                                                    this.handleDeleted(e, arrayHelpers, index)
                                                                }
                                                            >
                                                                <i className="fa fa-trash" aria-hidden="true" />
                                                            </button>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            ))
                                        ) : (
                                            <div />
                                        )}
                                    <div>
                                        <button
                                            className="button is-primary"
                                            type="button"
                                            onClick={() => {
                                                arrayHelpers.push({
                                                    participantName: "",
                                                    participantBirthday: "",
                                                    referenceKey: ""
                                                });
                                                nextSelected();
                                            }}
                                        >
                                            {currentLocale.addMinor}
                                        </button>
                                    </div>
                                </div>
                            )}
                        />
                    )}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    waiver: state.currentWaiver,
    signingInfo: state.signingInfo,
    pathParticipants: state.pathParticipants,
    linkedParticipant: state.pathParticipants.selectedParticipantsName,
    role: state.signingInfo.role,
    selected: state.pathParticipants.selected,
    participants: state.pathParticipants.participants
});

const mapActionsToProps = dispatch => ({
    getLinkedParticipants: value => dispatch(getLinkedParticipants(value)),
    removeParticipant: value => dispatch(removeParticipant(value)),
    nextSelected: () => dispatch({ type: NEXT_SELECTED })
});

const connector = connect(
    mapStateToProps,
    mapActionsToProps
);

export default connector(LinkedParticipantList);
